module.exports = __webpack_public_path__ + "static/media/Event-12.dae2dcdb.svg";